import { Empty } from 'antd';
import { useTranslation } from 'react-i18next';
import type { RoleCardRole } from '../../types';
import { RoleCard } from './RoleCard';

type RoleCardGridProps = {
  roles: RoleCardRole[];
  canDeleteRole: boolean;
  onView: (role: RoleCardRole) => void;
  onDelete?: (role: RoleCardRole) => void;
};

export function RoleCardGrid({
  roles,
  canDeleteRole,
  onView,
  onDelete,
}: RoleCardGridProps) {
  const { t } = useTranslation('authorization');

  if (roles.length === 0) {
    return (
      <Empty
        className="authorization-empty-state"
        description={t('roleCard.empty')}
      />
    );
  }

  return (
    <div className="authorization-custom-role-grid">
      {roles.map((role) => (
        <RoleCard
          key={role.id}
          role={role}
          canDeleteRole={canDeleteRole}
          onView={onView}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
}
